<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-edit-2" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Edit Claim</h4>
              <small style="opacity: 0.8;">Update diagnosis and treatment summary</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">
          <div class="row" v-if="claimdetails && claimdetails.patient">
            <div class="col-lg-9 col-md-12 mx-auto">
              <div class="card shadow form-card">
                <div class="form-card-header">
                  <div class="section-number">1</div>
                  <h6 class="mb-0 font-weight-bold text-white">Claim Details</h6>
                </div>

                <div class="card-body px-4 py-4">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label class="form-label">Date of Care</label>
                      <date-picker v-model="claimdetails.seen_date" valueType="format" style="width: 100%;"></date-picker>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="form-label">Select Diagnosis</label>
                      <select class="form-control styled-select" v-model="claimdetails.diagnosis.id">
                        <option v-for="dis in diseases" v-bind:key="dis.id" :value="dis.id">
                          {{ dis.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-4">
                      <label class="form-label">Enrollee RIVCHPP Number</label>
                      <input type="text" class="form-control" :value="claimdetails.patient.id_card_number" disabled />
                    </div>

                    <div class="form-group col-md-4">
                      <label class="form-label">Enrollee Full Name</label>
                      <input type="text" class="form-control"
                        :value="`${claimdetails.patient.firstname} ${claimdetails.patient.lastname}`" disabled />
                    </div>

                    <div class="form-group col-md-4">
                      <label class="form-label">Enrollee Phone Number</label>
                      <input type="text" class="form-control" :value="claimdetails.patient.phone_number" disabled />
                    </div>

                    <div class="form-group col-md-12">
                      <label class="form-label">Treatment Summary</label>
                      <textarea rows="5" class="form-control" v-model="claimdetails.treatment"></textarea>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <button class="btn btn-submit" @click="updateClaim">
                      <i class="fe fe-check mr-1"></i> Update Claim
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="text-center text-muted py-5">
            <i class="fe fe-loader" style="font-size: 2rem; opacity: .4;"></i>
            <p class="mt-2 mb-0">Loading claim details…</p>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import DatePicker from "vue2-datepicker";

export default {
  components: {
    Navbar,
    Loading,
    DatePicker,
  },
  data() {
    return {
      editor: ClassicEditor,
      user: null,
      agencies: "",
      employees: "",
      clients: "",
      client: "",
      selected_user: "",
      claims: "",
      diseases: "",
      singleclaim: "",
      claimdetails: "",
      clientdetail: "",
      min: 100000000000000000,
      max: 1000000000000000000,
      edit: false,
      isLoading: false,
      fullPage: true,
      claim: {
        provider_id: "",
        client_id: "",
        diagnosis: "",
        treatment: "",
        client_name: "",
        seen_date: "",
        cost: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    randomNumber: function () {
      let authorization_code = Math.floor(
        Math.random() * (this.max - this.min + 1) + this.min
      );
      return authorization_code;
    },
  },
  methods: {
    getClaim() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/detailedClaim/${this.$route.params.id}`)
        .then((response) => {
          this.singleclaim = response.data;
          this.comment = response.data.comments[0];
          this.claimdetails = response.data.singleclaim[0];
          //single client
          this.axios
            .get(
              `/api/v1/auth/user/${response.data.singleclaim[0].client_name}`
            )
            .then((response) => {
              this.clientdetail = response.data.user;
              console.log(response);
            });
          //end of single client

          // Prepared by
          this.axios
            .get(`/api/v1/auth/user/${response.data.singleclaim[0].user_id}`)
            .then((response) => {
              this.prepared_by = response.data.user;
              console.log(response);
            });
          //end of Prepared by
          //get facility
          this.axios
            .get(
              `/api/v1/auth/detailedProviderHmo/${response.data.singleclaim[0].provider_id}`
            )
            .then((response) => {
              this.facility = response.data.data[0];
              console.log(response);
            });
          //end of get facility
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },


    getDiseases() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/diagnosis`)
        .then((response) => {
          this.diseases = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    updateClaim() {
      this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/editClaim/" + this.claimdetails.id, {
            provider_id: this.claimdetails.provider_id,
            user_id: this.user.id,
            agency_id: 407465,
            client_name: this.claimdetails.client_name,
            seen_date: this.claimdetails.seen_date,
            diagnosis: this.claimdetails.diagnosis.id,
            treatment: this.claimdetails.treatment,
            cost: 0.0,
          })

          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("updated Successfully", {
              position: "top-center",
              duration: 3000,
            });
             this.$router.push(`/service-processing-form/${this.claimdetails.id}`)
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
          });
    },
  },
  created() {
    this.getDiseases();
    this.getClaim();
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}
.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.form-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.form-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.section-number {
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  font-size: .78rem;
  font-weight: 700;
}

.form-label { font-weight: 600; font-size: .85rem; color: #374151; margin-bottom: 6px; }
.styled-select { border: 1.5px solid #e2e8f0; border-radius: 8px; padding: 9px 12px; font-size: .88rem; }
.styled-select:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37,99,235,.1); outline: none; }

.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37, 99, 235, 0.15);
}

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 10px 22px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
</style>
